import axios from "axios";
import { toast } from "sonner";
import { markSynced, markSyncing, markSyncFailed } from "@/lib/syncStatus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage as fallback (for browsers blocking 3rd-party cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("orden_access_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Offline guard: block mutations when navigator says we're offline.
  const method = (config.method || "get").toLowerCase();
  if (typeof navigator !== "undefined" && navigator.onLine === false && method !== "get") {
    toast.error("Sin conexión — esta acción requiere internet.");
    return Promise.reject({ __offline: true, message: "Sin conexión", config });
  }
  markSyncing();
  return config;
});

// Friendly toast for offline-induced read failures.
api.interceptors.response.use(
  (resp) => {
    markSynced();
    return resp;
  },
  (error) => {
    markSyncFailed();
    const offline = typeof navigator !== "undefined" && navigator.onLine === false;
    if (offline && !error?.__offline) {
      toast.error("Sin conexión — mostrando datos guardados.");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND}${pathOrUrl}`;
  return pathOrUrl;
}

export function formatCurrency(n) {
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(n || 0));
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" });
  } catch { return iso; }
}
